/* global $, moment */

import { getTemplate } from "../template-helper";
import { deleteRecord, fetchFromBindUrl } from "../../libs/binding";
import { waiter, uuidv4 } from "../../util/utils";
import { confirm, viewDialog } from "../../util/dialogs";
import { createXls } from "../../util/exporters";
import { createColDef } from "../../util/z-grid-helper";
import { tr, translateElement } from "../../util/locales";

const COMPONENT_NAME = "z-list" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
            
        class ListComponent extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback(){
                this.init();
                const readonly = this.hasAttribute("readonly") ;
                if(this.grid && this.grid.setEditable){
                    this.grid.setEditable(!readonly) ;
                }
                if(this.btnEdit){
                    if(readonly){
                        this.btnEdit.classList.remove("active") ;
                    }else{
                        this.btnEdit.classList.add("active") ;
                    }
                }
                translateElement(this);
            }

            init(){
                this.grid = this.querySelector("z-grid") ;
                if(!this.grid){ 
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
                }
                

                const gridContainer = this.querySelector(".z-list-grid-container") ;
                this.gridContainer = gridContainer ;

                const btnCreate = this.querySelector(".z-list-btn-create");
                btnCreate.addEventListener("click", ()=>{
                    const openUrl = this.grid.getAttribute("z-open-url") ;
                    const url = openUrl.replace(/\/read.*$/, "/create") ;
                    window.location.href = url ;
                }) ;
                this.btnCreate = btnCreate;
                
                const btnEdit = this.querySelector(".z-list-btn-editable");
                this.btnEdit = btnEdit ;
                btnEdit.addEventListener("click", ()=>{
                    if(btnEdit.classList.contains("active")){
                        btnEdit.classList.remove("active") ;
                        this.grid.setEditable(false) ;
                    }else{
                        btnEdit.classList.add("active") ;
                        let autoSave = true;
                        if(this.getAttribute("z-edit-autosave") === "false"){
                            autoSave = false;
                        }
                        this.grid.setEditable(true, autoSave) ;
                    }
                }) ;

                const btnImportExcel = this.querySelector(".z-list-import-xls") ;
                btnImportExcel.addEventListener("click", ()=>{
                    window.dialogs.viewDialog({
                        route: "/data/excel/importintable/"+this.getAttribute("z-app")+"/"+this.getAttribute("z-model-id")
                    }, {
                        size: "fullscreen"
                    }, ()=>{
                        if(this.hasAttribute("z-server-side")){
                            this.grid.refreshServerSide() ;
                        }else{
                            waiter(fetchFromBindUrl(this.grid)) ; 
                        }
                    }) ;
                }) ;
                
                const btnClear = this.querySelector(".z-list-clear") ;
                btnClear.addEventListener("click", ()=>{
                    window.dialogs.confirm(tr("grid.areYouSureDeleteAll"),{focusToNoButton: true}).then((yes)=>{
                        if(yes){
                            let model = this.getAttribute("z-model")  ;
                            if(!model){
                                const resourceUrl = this.getAttribute("z-resource-url")  ;
                                if(resourceUrl){
                                    const splittedUrl = resourceUrl.split("/") ;
                                    model = splittedUrl[splittedUrl.indexOf("rest")+1] ;
                                    if(model && model.includes("?")){
                                        const indexQuery = model.indexOf("?") ;
                                        model = model.substring(0, indexQuery) ;
                                    }
                                }
                            }
                            if(!model){ throw "Can't get model of grid" ; }

                            const changes = [] ;
                            changes.push({
                                table:model,
                                action: "delete",
                                where: { _id: {$notNull: true} }
                            }) ;
                            
                            let restApi = window.restApi;
                            if(this.hasAttribute("z-app")){
                                restApi = window.getRestApi(this.getAttribute("z-app")) ;
                            }
                            waiter(restApi.update(changes).then(()=>{ 
                                if(this.hasAttribute("z-server-side")){
                                    this.grid.refreshServerSide() ;
                                }else{
                                    return fetchFromBindUrl(this.grid) ; 
                                }
                            })) ;
                        }
                    }) ;
                }) ;


                this.btnContainer = this.querySelector(".z-list-btn-container") ;

                if(!this.hasAttribute("z-editable")){
                    btnEdit.style.display = "none" ;
                    btnImportExcel.style.display = "none" ;
                    btnClear.style.display = "none" ;
                }
                if(!this.hasAttribute("z-model-id")){
                    btnImportExcel.style.display = "none" ;
                }
                
                const btnSaveState = this.querySelector(".z-list-btn-save-state");
                btnSaveState.addEventListener("click", ()=>{
                    this.grid.saveColumnState() ;
                }) ;
                
                const btnResetState = this.querySelector(".z-list-btn-reset-state");
                btnResetState.addEventListener("click", ()=>{
                    this.grid.resetColumnState() ;
                }) ;
                
                const btnRefresh = this.querySelector(".z-list-btn-refresh");
                btnRefresh.addEventListener("click", ()=>{
                    if(this.hasAttribute("z-server-side")){
                        this.grid.refreshServerSide() ;
                    }else{
                        waiter(fetchFromBindUrl(this.grid))
                        .then(()=> {
                            this.grid.reInit();
                        });
                    }
                }) ;
                
                const inputSearch = this.querySelector(".z-list-input-search");
                inputSearch.addEventListener("keyup", (e)=>{
                    if(e.keyCode === 13){
                        this.grid.setQuickFilter(inputSearch.value);
                    }
                }) ;
                this.inputSearch = inputSearch;
                
                const clearSearch = this.querySelector(".z-list-clear-search");
                clearSearch.addEventListener("click", ()=>{
                    this.applyFilter({
                        filter: {
                            quick: "",
                            model: {}
                        }
                    }) ;
                }) ;

                const saveSearch = this.querySelector(".z-list-save-search");
                saveSearch.addEventListener("click", ()=>{
                    this.saveSearch() ;
                }) ;
                
                const exportXls = this.querySelector(".z-list-export-xls");
                exportXls.addEventListener("click", ()=>{
                    let data = [] ;
			        data.push(this.grid.getXlsData()) ;
                    data.forEach((d) => {
                        d.sheetName = this.title||"export" ;
                    }) ;
                    var xlsData = {
                        filename : (this.title||"export")+" - "+moment().format("L LT")+".xlsx",
                        sheets : data
                    } ;
                    waiter(createXls(xlsData)) ;
                }) ;
                
                this.savedFilters = this.querySelector(".z-list-saved-filters");
                // savedFilters.getSavedFilters = ()=>{
                //     let key = "grid_filter_"+this.grid.id ;
                //     const strFilters = localStorage.getItem(key) ; 
                //     if(strFilters){
                //         return JSON.parse(strFilters) ;
                //     }
                // } ;
                // savedFilters.setAttribute("z-bind-url", "getSavedFilters");

                const dropdownToggleButtons = this.querySelectorAll(".dropdown-toggle") ;
                for(let i=0; i<dropdownToggleButtons.length; i++){
                    const dropdownButton = dropdownToggleButtons[i] ;
                    const dropdown = dropdownButton.parentElement ;
                    const dropdownMenu = dropdown.querySelector(".dropdown-menu") ;
                    dropdownToggleButtons[i].addEventListener("click", ()=>{
                        if(dropdown.classList.contains("show")){
                            dropdown.classList.remove("show");
                            dropdownMenu.classList.remove("show");
                        }else{
                            dropdown.classList.add("show");
                            dropdownMenu.classList.add("show");
                        }
                    }) ;
                }

                if(!this.grid){ 
                    this.initList() ;
                }

                this.grid.addEventListener("deleteRows", (ev)=>{
                    if(this.hasAttribute("z-editable")){
                        confirm(tr("form.areYouSureDeleteTheseLines", {count: ev.detail.length})).then(yes=>{
                            if(yes){
                                let fieldId = "id" ;
                                if(this.grid.hasAttribute("z-field-id")){
                                    fieldId = this.grid.getAttribute("z-field-id") ;
                                }
                                let model = this.getAttribute("z-model")  ;
                                if(!model){
                                    const resourceUrl = this.getAttribute("z-resource-url")  ;
                                    if(resourceUrl){
                                        const splittedUrl = resourceUrl.split("/") ;
                                        model = splittedUrl[splittedUrl.indexOf("rest")+1] ;
                                        if(model && model.includes("?")){
                                            const indexQuery = model.indexOf("?") ;
                                            model = model.substring(0, indexQuery) ;
                                        }
                                    }
                                }
                                if(!model){ throw "Can't get model of grid" ; }

                                let changes = [] ;
                                let where = {} ; 
                                where[fieldId] = { $in : [] } ;
                                for(let data of ev.detail){
                                    where[fieldId].$in.push(data[fieldId]) ;
                                    if(where[fieldId].$in.length === 1000){
                                        changes.push({
                                            table:model,
                                            action: "delete",
                                            where: where
                                        }) ;
                                        where = {} ; 
                                        where[fieldId] = { $in : [] } ;
                                    }
                                }
                                if(where[fieldId].$in.length > 0){
                                    changes.push({
                                        table:model,
                                        action: "delete",
                                        where: where
                                    }) ;
                                }
                                
                                let restApi = window.restApi;
                                if(this.hasAttribute("z-app")){
                                    restApi = window.getRestApi(this.getAttribute("z-app")) ;
                                }
                                waiter(restApi.update(changes).then(()=>{ 
                                    if(this.hasAttribute("z-server-side")){
                                        this.grid.refreshServerSide() ;
                                    }else{
                                        return fetchFromBindUrl(this.grid) ; 
                                    }
                                })) ;
                            }
                        }) ;
                    }
                }) ;

                const colVisPlaceholder = this.querySelector(".z-col-vis-placeholder") ;

                
                this.grid.addEventListener("columnsCreated", (ev)=>{
                    const existingItems = colVisPlaceholder.parentElement.querySelectorAll(".dropdown-item");
                    for(let item of existingItems){
                        item.parentElement.removeChild(item) ;
                    }
                    for(let col of ev.detail){
                        if(!col.field) { continue ; }
                        if(col.technicalColumn) { continue ; }
                        const visItem = document.createElement("DIV") ;
                        visItem.className = "dropdown-item" ;
                        const checkboxVis = document.createElement("INPUT") ;
                        checkboxVis.type = "checkbox" ;
                        checkboxVis.className = "mr-1" ;
                        checkboxVis.checked = !col.hide ;
                        checkboxVis.addEventListener("change", ()=>{
                            this.onColumnVisibilityChange(col.field, checkboxVis.checked) ;
                        }) ;
                        visItem.appendChild(checkboxVis) ;
                        const spanLabel = document.createElement("SPAN") ;
                        spanLabel.innerHTML = col.headerName || col.field ;
                        visItem.appendChild(spanLabel) ;

                        colVisPlaceholder.parentElement.insertBefore(visItem, colVisPlaceholder) ;
                    }
                }) ;


                this.grid.addEventListener("stateChanged", (ev)=>{
                    const newState = ev.detail ;
                    if(!this.getRootNode().__zzBindData){ return ; }
                    if(this.getRootNode().querySelector("body").classList.contains("z-embedded")){ return ; }
                    const _globals = this.getRootNode().__zzBindData._globals;
                    if(_globals && _globals.context){
                        if(_globals.context.currentScreen && _globals.context.currentScreen.route && _globals.context.currentScreen.route.includes("/:grid_state?")){
                            let strStates = localStorage.getItem("grid_states") ;
                            let states = {} ;
                            if(strStates){
                                try{
                                    states = JSON.parse(strStates) ;
                                }catch(err){ console.error("Can't parse grid states", err) ;}
                            }
                            const newSateId = uuidv4();
                            states[newSateId] = {
                                date: new Date().toISOString(), 
                                state: newState.state, 
                                filter: newState.filter,
                                grid_route: _globals.context.currentScreen.route
                            } ;
                            let statesIds = Object.keys(states) ;
                            if(statesIds.length>20){
                                statesIds = statesIds.sort((s1, s2)=>{
                                    return states[s1].date>states[s2].date?1:-1 ;
                                }) ;
                                while(statesIds.length>20){
                                    const idToDelete = statesIds.shift() ;
                                    delete states[idToDelete] ;
                                }
                            }
                            localStorage.setItem("grid_states", JSON.stringify(states)) ;
                            _globals.params.grid_state = newSateId ;
                        }
                    }
                });

                if(this.getRootNode() && this.getRootNode().getData){
                    const _globals = this.getRootNode().getData()._globals;
                    if(_globals && _globals.params && _globals.params.grid_state){
                        let strStates = localStorage.getItem("grid_states") ;
                        let states = {} ;
                        if(strStates){
                            try{
                                states = JSON.parse(strStates) ;
                            }catch(err){ console.error("Can't parse grid states", err) ;}
                        }
                        if(states[_globals.params.grid_state]){
                            this.grid.applyState(states[_globals.params.grid_state].state) ;
                            if(states[_globals.params.grid_state].filter){
                                this.applyFilter({filter: states[_globals.params.grid_state].filter}) ;
                            }
                        }
                    }
                }

                this.initButtons().then(() => {
                    $(this).find("[data-toggle='popover']").popover();
                });
                this.renderFilters() ;

                if(this.valueSetBeforeInit){
                    this.grid.value = this.valueSetBeforeInit ;
                    delete this.valueSetBeforeInit;
                }
            }

            

            initButtons(){
                let promiseButtons = Promise.resolve();
                if(this.hasAttribute("z-buttons")){
                    const attrButtons = this.getAttribute("z-buttons") ;
                    let buttonsDef ;
                    if(attrButtons[0] === "["){
                        buttonsDef = JSON.parse(attrButtons) ;
                    }else{
                        buttonsDef = this[attrButtons] ;
                    }
                    if(!buttonsDef){
                        console.error("Missing function or array "+attrButtons) ;
                    }
                    if(typeof(buttonsDef) === "function"){
                        const columnDefResult = buttonsDef() ;
                        if(columnDefResult && columnDefResult.constructor === Promise){
                            promiseButtons = columnDefResult ;
                        }else{
                            promiseButtons = Promise.resolve(columnDefResult) ;
                        }
                    }else{
                        promiseButtons = Promise.resolve(buttonsDef) ;
                    }
                    if(promiseButtons){
                        promiseButtons.then((buttonsDef)=>{
                            for(let btDef of buttonsDef){
                                const idButton = "bt_"+btDef.action ;

                                let button = this.querySelector("#"+idButton) ;
                                if(!button){
                                    const divButton = document.createElement("DIV") ;
                                    button = document.createElement("BUTTON") ;
                                    divButton.appendChild(button) ;
                                    button.id = idButton;
                                    button.type = "button" ;
                                    button.className = "btn btn-outline-primary btn-sm ml-2" ;
                                    if(btDef.icon){
                                        const icon = document.createElement("I");
                                        icon.className = btDef.icon ;
                                        button.appendChild(icon) ;
                                    }
                                    if(btDef.label){
                                        const span = document.createElement("SPAN") ;
                                        span.innerHTML = btDef.label ;
                                        button.appendChild(span) ;
                                    }
                                    button.setAttribute("data-toggle", "popover");
                                    button.setAttribute("data-placement", "left");
                                    button.setAttribute("data-content", ((action)=>{
                                        switch (action) {
                                            case 'wizard-create-grid-form':
                                                return tr("grid.wizardDesc") ;
                                            case 'settings':
                                                return tr("grid.settingsDesc") ;
                                            case 'wizard-create-columns':
                                                return tr('grid.wizardColumnsDesc') ;
                                            default:
                                                return '' ;
                                        }
                                    })(btDef.action));
                                    button.setAttribute("data-trigger", "hover");
                                    this.btnContainer.appendChild(divButton) ;
                                }
                                button.addEventListener("click", ()=>{
                                    this.dispatchEvent(new CustomEvent(btDef.action, {detail : {}, bubbles: true}));
                                });
                            }
                        }) ;
                    }
                }
                return promiseButtons;
            }

            initList(){

                this.grid = this.querySelector("z-grid") ;
                if(this.grid){ return ;}
                // this.gridContainer.innerHTML = "" ;

                let allColumns = this.querySelectorAll("z-col") ;
                let mobileRender = this.querySelector("z-mobile-render") ;
                

                let resourceUrl = this.getAttribute("z-resource-url") ;
                let openUrl = this.getAttribute("z-open-url") ;
                let fieldId = this.getAttribute("z-field-id") ;
                let modelDef = null;

                let schema = window.APP.schema ;
                if(this.hasAttribute("z-app") && window.APPS[this.getAttribute("z-app")]){
                    if(window.APPS[this.getAttribute("z-app")]){
                        schema = window.APPS[this.getAttribute("z-app")].schema ;
                    }
                }

                if(this.hasAttribute("z-model")){
                    const model = this.getAttribute("z-model") ;
                    const filter =  this.getAttribute("z-filter") ;
                    if(model){
                        modelDef = schema.models.find(m => m.name === model) ;
                        if(!resourceUrl){
                            resourceUrl =  "/api/rest/"+model ;
                            if(this.hasAttribute("z-app")){
                                resourceUrl =  "/api/"+this.getAttribute("z-app")+"/rest/"+model ;
                            }
                            if(filter){
                                resourceUrl += "?"+filter ;
                            }else if(modelDef && modelDef.columns && modelDef.columns.find(c=>c.name === "_index")){
                                resourceUrl += "?orderBy=_index" ;
                            }
                        }
    
                        if(!fieldId){
                            fieldId = "id" ;
                            if(modelDef){
                                const fieldPk = modelDef.columns.find(c => c.unique) ;
                                if(fieldPk){
                                    fieldId = fieldPk.name ;
                                }
                            }
                        }
    
                        if(!this.getAttribute("z-open-url") && this.hasAttribute("z-has-form")){
                            let currentHref = window.location.href ;
                            currentHref = currentHref.replace(/\/list\/{0,1}.*$/, "/form/read/{{"+fieldId+"}}") ;
                            let inRoutes = true ;
                            if(window.router){
                                const hashHref = currentHref.substring(currentHref.indexOf("#")+1) ;
                                inRoutes = window.router._routes.some(r=>r.regexp.test(hashHref)) ;
                            }
                            if(inRoutes){
                                openUrl = currentHref ;
                            }
                        }

                        
                    }
                }


                this.openUrl = openUrl ;

                let grid = this.grid ;
                if(!this.grid){
                    grid = document.createElement("z-grid") ;
                    grid.style.height = "300px" ;
                    grid.style.minHeight = "100%" ;
                    let id = this.id ;
                    if(!id){
                        id = this.getAttribute("z-model") ;
                    }
                    grid.id = id+"_grid" ;

                    if(this.hasAttribute("z-theme")){
                        grid.setAttribute("z-theme", this.getAttribute("z-theme")) ;
                    }

                    for(let a = 0; a<this.attributes.length; a++){
                        let att = this.attributes[a] ;
                        if(/^z-row-class-rule-/.test(att.name) || /^z-grid-option-/.test(att.name)){
                            grid.setAttribute(att.name, att.value) ;
                        }
                    }

                    if(this.hasAttribute("z-app")){
                        grid.setAttribute("z-app", this.getAttribute("z-app")) ;
                    }

                    if(this.hasAttribute("z-editable")){
                        grid.setAttribute("z-row-selection", "multiple") ;
                    }

                    if(mobileRender){
                        grid.appendChild(mobileRender) ;
                    }

                    if(this.hasAttribute("z-col-def")){
                        grid.setAttribute("z-col-def", this.getAttribute("z-col-def")) ;
                    }else if(allColumns.length>0){
                        for(let col of allColumns){
                            const colField = col.getAttribute("ag-field") ;
                            if(colField && modelDef){
                                const schemaColumn = modelDef.columns.find(c => c.name === colField) ;
                                if(schemaColumn){
                                    col.setAttribute("z-model", modelDef.name+"."+colField) ;
                                }
                            }
                            grid.appendChild(col) ;
    
    
                            // const visItem = document.createElement("DIV") ;
                            // visItem.className = "dropdown-item" ;
                            // const checkboxVis = document.createElement("INPUT") ;
                            // checkboxVis.type = "checkbox" ;
                            // checkboxVis.className = "mr-1" ;
                            // checkboxVis.checked = !col.hasAttribute("ag-hide") ;
                            // checkboxVis.addEventListener("change", ()=>{
                            //     this.onColumnVisibilityChange(colField, checkboxVis.checked) ;
                            // }) ;
                            // visItem.appendChild(checkboxVis) ;
                            // const spanLabel = document.createElement("SPAN") ;
                            // spanLabel.innerHTML = col.getAttribute("ag-header-name") ;
                            // visItem.appendChild(spanLabel) ;
    
                            // colVisPlaceholder.parentElement.insertBefore(visItem, colVisPlaceholder) ;
                        }
                    }else if(modelDef){
                        const columnDefs= modelDef.columns.map((c)=> { 
                            c.tableName = modelDef.name ;
                            const colDef = createColDef(c, this.getAttribute("z-app")) ;
                            colDef.editable = true;
                            if(c.name[0] === "_"){
                                colDef.hide = true ;
                            }
                            return colDef ;
                        }) ;
                        const funcName = "getFieldColDef"+uuidv4().replace(/-/g, "") ;
                        window[funcName] = function(){
                            return columnDefs ;
                        } ;
                        grid.setAttribute("z-col-def", "window."+funcName+"()") ;
                    }





                    this.gridContainer.appendChild(grid) ;
                }

                if(openUrl){
                    grid.setAttribute("z-open-url", openUrl) ;
                }

                if(this.hasAttribute("z-server-side")){
                    grid.setAttribute("z-server-side", "true") ;
                    if(this.hasAttribute("z-server-search")){
                        grid.setAttribute("z-server-search", this.getAttribute("z-server-search")) ;
                    }
                    if(this.hasAttribute("z-server-orderby")){
                        grid.setAttribute("z-server-orderby", this.getAttribute("z-server-orderby")) ;
                    }
                }else{
                    if(resourceUrl){
                        grid.setAttribute("z-bind-url", resourceUrl) ;
                    }
                }
                if(fieldId){
                    grid.setAttribute("z-field-id", fieldId) ;
                }

                if(this.hasAttribute("z-editable")){
                    grid.setAttribute("z-editable", "true") ;
                }
                if(this.hasAttribute("z-no-new-line-auto")){
                    grid.setAttribute("z-no-new-line-auto", "true") ;
                }

                if(this.hasAttribute("z-always-editable")){
                    grid.setAttribute("z-editable", "true") ;
                }
                if(this.hasAttribute("z-auto-save")){
                    grid.setAttribute("auto-save", "true") ;
                }
                if(this.hasAttribute("z-save-url")){
                    grid.setAttribute("z-save-url", this.getAttribute("z-save-url")) ;
                }
                
                if(this.hasAttribute("z-model")){
                    grid.setAttribute("z-model", this.getAttribute("z-model")) ;
                }
                
                if(this.hasAttribute("z-bind")){
                    grid.setAttribute("z-bind", this.getAttribute("z-bind")) ;
                    this.removeAttribute("z-bind") ;
                }

                if(!openUrl){
                    this.btnCreate.style.display = "none" ;
                }

                grid.editable = !this.hasAttribute("readonly") ;
                

                this.grid = grid ;
            }

            get title(){
                return this.getAttribute("z-title") ;
            }

            set title(title){
                return this.setAttribute("z-title", title) ;
            }

            get value(){
                if(!this.grid){ return this.valueSetBeforeInit; }
                return this.grid.value ;
            }

            set value(value){
                if(!value){ 
                    value = [] ; 
                }
                if(this.grid){
                    this.grid.value = value;
                }else{
                    this.valueSetBeforeInit = value;
                }
            }

            notifyChange(){
                if(this.grid){
                    this.grid.notifyChange() ;
                }
            }

            onColumnVisibilityChange(colField, visible){
                this.grid.setColumnVisible(colField, visible) ;
            }

            getSavedFilters(){
                let key = "grid_filter_"+this.grid.id ;
                const strFilters = localStorage.getItem(key) ; 
                if(!strFilters){ 
                    return [] ;
                }
                try{
                    return JSON.parse(strFilters) ;
                }catch(err){
                    return [] ;
                }
            }

            applyFilter(filter){
                if(filter.filter.quick){
                    this.inputSearch.value = filter.filter.quick ;
                }else{
                    this.inputSearch.value = "" ;
                }
                this.grid.applyFilter(filter.filter) ;
            }

            removeFilter(filterIndex){
                let key = "grid_filter_"+this.grid.id ;
                const savedFilters = this.getSavedFilters() ;
                savedFilters.splice(filterIndex, 1) ;
                localStorage.setItem(key, JSON.stringify(savedFilters)) ; 
                this.renderFilters() ;
            }

            renderFilters(){
                const dropdownSavedFilters = this.querySelector(".z-list-dropdown-saved-filters");
                const dropdownSave = this.querySelector(".z-list-dropdown-save-search");
                while(dropdownSavedFilters.childElementCount>1){
                    dropdownSavedFilters.removeChild(dropdownSavedFilters.firstElementChild) ;
                }
                const filters = this.getSavedFilters();
                for(let i = 0; i<filters.length; i++){
                    const filter = filters[i] ;
                    const divItem = document.createElement("div") ;
                    divItem.className = "dropdown-item" ;
                    const divFilter = document.createElement("div") ;
                    divFilter.className = "d-flex" ;
                    const buttonFilter = document.createElement("button") ;
                    buttonFilter.className = "bnt-link btn btn-sm flex-grow-1" ;
                    buttonFilter.innerHTML = filter.name ;
                    buttonFilter.addEventListener("click", ()=>{
                        this.applyFilter(filter) ;
                    }) ;
                    const buttonDelete = document.createElement("button") ;
                    buttonDelete.className = "bnt-link btn btn-sm ml-2" ;
                    buttonDelete.innerHTML = '<i class="fas fa-trash text-danger"></i>' ;
                    buttonDelete.addEventListener("click", ()=>{
                        this.removeFilter(i) ;
                    }) ;

                    divItem.appendChild(divFilter) ;
                    divFilter.appendChild(buttonFilter) ;
                    divFilter.appendChild(buttonDelete) ;
                    dropdownSavedFilters.insertBefore(divItem, dropdownSave) ;
                }
            }

            saveSearch(){
                viewDialog(`
                <div class="form-group">
                    <label for="searchName" data-i18n="grid.filterName"></label>
                    <input type="text" class="form-control" id="searchName" />
                </div>
                <button type="button" id="validate" class="btn btn-primary" data-i18n="form.validate"></button>
                <script>
                    document.getElementById("validate").addEventListener("click", function(){
                        getRootData()._globals.actions.closePopup(document.getElementById("searchName").value) ;
                    }) ;
                </script>
                `, (name)=>{
                    if(name){
                        let key = "grid_filter_"+this.grid.id ;
                        let filter = {
                            name: name,
                            filter: this.grid.getCurrentFilter()
                        } ;
                        filter.filter.quick = this.inputSearch.value ;
                        const filters = this.getSavedFilters() ;
                        filters.push(filter) ;
                        localStorage.setItem(key, JSON.stringify(filters)) ; 
                        this.renderFilters() ;
                    }
                }) ;
            }


            static get observedAttributes() {
                return ["readonly"/*, "z-col-def"*/];
            }
    
            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'readonly':
                        if(this.grid){
                            const readonly = this.hasAttribute("readonly") ;
                            this.grid.setEditable(!readonly) ;
                            if(readonly){
                                this.btnEdit.classList.remove("active") ;
                            }else{
                                this.btnEdit.classList.add("active") ;
                            }
                            //this.grid.editable = !this.hasAttribute("readonly") ;
                        }
                        break;
                    // case 'z-col-def':
                    //     if(this.grid){
                    //         this.grid.setAttribute('z-col-def', this.getAttribute("z-col-def")) ;
                    //     }
                    //     break;
                   
                }
            }
        }
        customElements.define(COMPONENT_NAME, ListComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}

